import React from 'react';
import AppBar from '../../commons/AppBar'
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';
import ListBeneficiari from '../../commons/ListBeneficiari';
import AdminBeneficiarEdit from '../../commons/dialogs/AdminBeneficiarEdit';
import Utils from '../../providers/Utils';
import FromServer from './FromServer';



export default class Beneficiari extends SpecificComponent   {
    constructor(props) {
      super(props);
       this.state = {
        listBeneficiari:[],
        objAdmin:{}, 
        isOpenEdit:false,
        tipuriEducatie:new Utils().nivelEducatei
}
    }

     componentDidMount(){
         this.getBeneficiari()
    }


    getBeneficiari = async()=>{

        let fs = new FromServer();

        let getBeneficiari =await fs.getBeneficiari();

        if(getBeneficiari.r){

            this.setState({listBeneficiari:getBeneficiari.c})
        }
       
        
    }

    beneficiarChange=(e,ev) =>{
        let cloneListBeneficiari = [...this.state.listBeneficiari]

        let idx = cloneListBeneficiari.findIndex(i=>i.id_beneficiar === e.id_beneficiar)

        cloneListBeneficiari[idx].nume_beneficiar = ev.target.value

        this.setState({listBeneficiari:cloneListBeneficiari})
    }

    administratorChange=(e,ev) =>{
        let cloneListBeneficiari = [...this.state.listBeneficiari]

        let idx = cloneListBeneficiari.findIndex(i=>i.id_beneficiar === e.id_beneficiar)

        cloneListBeneficiari[idx].nume_administrator = ev.target.value

        this.setState({listBeneficiari:cloneListBeneficiari})
    }

    updateBeneficiar = async(e) =>{
        let fs = new FromServer();

        if(e.id_beneficiar !== null){

            let update =await fs.updateBeneficiar({nume:e.nume_beneficiar}, {id:e.id_beneficiar})
          

            if(update.r){
               this.getBeneficiari()
            }
        }else{
          
            let insert = await fs.insertBeneficiar({nume:e.nume_beneficiar})

            if(insert.r){
                this.getBeneficiari()
            }
        }

       
    }

    updateAdministrator = async(e) =>{
        let fs = new FromServer()
 

        if(e.id_administrator !== null){
        
            let update = await fs.updateAdministrator({nume:e.nume_administrator}, {id:e.id_administrator})

            if(update.r){
                this.getBeneficiari()
            }

        }else{
            let insert = await fs.insertAdministrator({nume:e.nume_administrator, id_beneficiar:e.id_beneficiar})

            if(insert.r){
                this.getBeneficiari()
            }
        }
    }

    openEditAdmin = async (e)=>{
        let fs = new FromServer();

        let getAdmin = await fs.getAdmin(e.id_beneficiar)

      

        if(getAdmin.r){
            this.setState({
                isOpenEdit:true,
                objAdmin:getAdmin.c[0]
            })
        }
    }


    updateAdminDetalii = async() =>{
       

        let fs = new FromServer();

        let update = await fs.updateDetaliiAdmin(this.state.objAdmin)
        
       

        if(update.r){
            this.setState({isOpenEdit:false},()=>{
                this.getBeneficiari()
            })
        }
    
    
    }

    changeAdmin = n => ev =>{
        let clone = {...this.state.objAdmin}

        clone[n] = ev.target.value

        this.setState({objAdmin:clone})
    }
     render() { 
       return (
          <div>
               <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.beneficiari}  />


          <AdminBeneficiarEdit
            open={this.state.isOpenEdit}
            dialogClose={()=>{this.setState({isOpenEdit:false})}}
            admin={this.state.objAdmin}
            changeAdmin={this.changeAdmin}
            updateAdmin={this.updateAdminDetalii}
            limba={this.dictionary}
            tipuriEducatie={this.state.tipuriEducatie}
        />
                <div>
               
                    <ListBeneficiari
                        elemente={this.state.listBeneficiari}
                        onlyColumns={{nume_beneficiar:'nume_beneficiar', nume_administrator:'nume_administrator'}}
                        dict={this.dictionary}
                        beneficiarChange={this.beneficiarChange}
                        administratorChange={this.administratorChange}
                        updateBeneficiar={this.updateBeneficiar}
                        updateAdministrator={this.updateAdministrator}
                        openEditAdmin={this.openEditAdmin}
                        />
                </div>
              
         </div>
        );
       }
}